export class Slider {
	touch = {
		swipeThreshold: 50,
		translate: 0,
		start: {
			x: null,
			y: null,
		},
		delta: {
			min: 70,
			x: null,
			y: null,
		},
	};
	classes = {
		activeDot: `slider__dots-dot--active`,
	};

	constructor(root, itemsNum, photoClass, autoInit = false) {
		this.root = root;
		this.photoClass = photoClass || 'slider__item';
		this.itemsNum = +itemsNum || 1;
		this.active = 1;
		this.root.innerHTML = this._sliderMarkup();
		this.sliderContainer = this.root.querySelector('#sliderContainer');
		this.dotsContainer = this.root.querySelector('#sliderDots');
		this.btnLeft = this.root.querySelector('#sliderBtnLeft');
		this.btnRight = this.root.querySelector('#sliderBtnRight');
		if (autoInit) this.init();
	}

	init() {
		this._addHandlers();
		this.setActiveImage(this.active);
	}

	setActiveImage(id) {
		this.active = +id;
		this._setActiveDot(id);
		const itemLengthInPrecents = 100 / this.itemsNum;
		const translate = -(id - 1) * itemLengthInPrecents + '%';
		this.sliderContainer.style.transform = `translateX(${translate})`;
	}

	_setActiveDot(id) {
		const { activeDot } = this.classes;
		this.dotsContainer
			.querySelectorAll(`.${activeDot}`)
			.forEach(dot => dot.classList.remove(activeDot));

		this.dotsContainer
			.querySelector(`[data-image-id="${id}"]`)
			.classList.add(activeDot);
	}

	_createDots() {
		let markup = '';
		for (let i = 0; i < this.itemsNum; i++) {
			markup += `<button class="slider__dots-dot" id="dot" data-image-id="${
				i + 1
			}" aria-label="zdjęcie nr ${i + 1}"></button>`;
		}
		return markup;
	}

	_createImages() {
		let markup = '';
		for (let i = 0; i < this.itemsNum; i++) {
			markup += `<div class="slider__item ${this.photoClass}--${
				i + 1
			}" id="sliderItem"><div class="slider__item-img"></div></div>`;
		}
		return markup;
	}

	_sliderMarkup() {
		return `
		<div class="slider__box">
			<div class="slider__btns">
				<button class="slider__btns-btn slider__btns-btn-left" id="sliderBtnLeft" aria-label="poprzednie zdjęcie"><i class="ph ph-caret-left"></i></button>
				<button class="slider__btns-btn slider__btns-btn-right" id="sliderBtnRight" aria-label="następne zdjęcie"><i class="ph ph-caret-right"></i></button>
				</div>
				<div class="slider__container" id="sliderContainer">
				${this._createImages()}
				</div>
				</div>
				<div class="slider__dots" id="sliderDots">
					${this._createDots()}
				</div>`;
	}

	_addHandlers() {
		this.btnLeft.addEventListener('click', this._handleLeftArrowClick);
		this.btnRight.addEventListener('click', this._handleRightArrowClick);
		this.dotsContainer
			.querySelectorAll('#dot')
			.forEach(dot => dot.addEventListener('click', this._handleDotClick));
		this.sliderContainer.addEventListener('touchstart', this.handleTouchSart);
		this.sliderContainer.addEventListener('touchmove', this.handleTouchMove);
		this.sliderContainer.addEventListener('touchend', this.handleTouchEnd);
	}

	_handleLeftArrowClick = e => {
		e.preventDefault();
		if (!this.active) return;
		if (this.active === 1) this.setActiveImage(this.active);
		else this.setActiveImage(this.active - 1);
	};

	_handleRightArrowClick = e => {
		e.preventDefault();
		if (!this.active) return;
		if (this.active === this.itemsNum) this.setActiveImage(this.active);
		else this.setActiveImage(this.active + 1);
	};

	_handleDotClick = e => {
		e.preventDefault();
		this.setActiveImage(e.target.closest('#dot').dataset.imageId);
	};

	handleTouchSart = e => {
		const firstTouch = e.touches[0];
		this.touch.start.x = firstTouch.clientX;
		this.touch.start.y = firstTouch.clientY;
	};

	handleTouchMove = e => {
		//* UPDATE TOUCH STATE
		const { start } = this.touch;
		// Ensure the touch start values exist
		if (start.x === null || start.y === null) return;
		// Get the current touch position
		const curr = e.touches[0];
		// Calculate horizontal movement
		this.touch.delta.x = curr.clientX - start.x;
		// Calculate vertical movement
		this.touch.delta.y = curr.clientY - start.y;

		if (Math.abs(this.touch.delta.y) > Math.abs(this.touch.delta.x)) return;
		else e.preventDefault();

		//* CALCULATE TRANSLATE
		// Determine the item length in percentages
		const itemLengthInPercent = 100 / this.itemsNum;
		// Calculate new translate value in pixels
		const sliderWidth = this.sliderContainer.offsetWidth;
		// Convert px to %
		const deltaXInPercent = (this.touch.delta.x / sliderWidth) * 100;
		// Calculate the updated translate position
		const translate =
			-(this.active - 1) * itemLengthInPercent + deltaXInPercent;
		// Save the current translate position for further calculations
		this.touch.translate = translate;

		//* UPDATE TRANSFORM STYLE
		this.sliderContainer.style.transition = 'none';
		this.sliderContainer.style.transform = `translateX(${translate}%)`;
	};

	handleTouchEnd = e => {
		const { delta, swipeThreshold: threshold } = this.touch;
		this.sliderContainer.style.transition = '';
		if (delta.x > threshold) this._handleLeftArrowClick(e);
		else if (delta.x < -threshold) this._handleRightArrowClick(e);
		else this.setActiveImage(this.active);
		this._resetTouch();
	};

	_resetTouch() {
		this.touch = {
			...this.touch,
			translate: 0,
			start: {
				...this.touch.start,
				x: null,
				y: null,
			},
			delta: {
				...this.touch.delta,
				x: null,
				y: null,
			},
		};
	}
}
